'use client'
import { useState } from 'react'
import { useRouter } from 'next/navigation'
import MonkeArtwork from './artwork'
import SimilarListings from '@/components/similar-listings'
import MonkeCollectorTools from './collector-tools'
import MonkeTraitsAndRelated from './traits-and-related'
import MonkeHistoryPanel from './history'
import useCollectionRanks from '@/utils/hooks/useCollectionRanks'
import type { TraitItem } from '@/utils/nodemonkes'

export function MonkeArtPanel({ inscription, className }: { inscription: TraitItem; className: string }) {
	const [background, setBackground] = useState('transparent')
	const router = useRouter()
	return <>
		<div className={className} style={{ backgroundColor: background }}><MonkeArtwork id={inscription.id} /></div>
		<MonkeCollectorTools id={inscription.id} navigate={router.push} background={background} onBackground={setBackground} />
		<SimilarListings inscription={{ ...inscription, collection: { slug: 'nodemonkes', name: 'NodeMonkes' } }} />
		<MonkeTraitsAndRelated inscription={inscription} navigate={router.push} showRelated={false} />
	</>
}

export function MonkePageHistory({ id }: { id: string }) {
	const router = useRouter()
	const { data } = useCollectionRanks('nodemonkes')
	const rank = data?.ranks[id]
	return <div className="mb-6 space-y-4">
		{rank && <div className="rounded-lg border border-border p-3"><p className="text-sm font-semibold">OW rank #{rank.rank.toLocaleString()} {rank.tied > 1 ? `· ${rank.tied} tied` : ''}</p><p className="mt-1 text-xs leading-relaxed text-muted-foreground">Inverse-frequency score including None and trait count. Other ranking methods may differ.</p></div>}
		<MonkeHistoryPanel id={id} navigate={router.push} />
	</div>
}
